import useSWR from "swr";
import { api } from "@portal/arq-portal-core";

const alertasKey = "alertagestiona";
const alertasService = "/be/alertagestiona/";

const useAlertas = (userid:string,cia :string) =>  useSWR([alertasKey, userid], ()=>api.post(alertasService,{"Entrada":{"cia":cia}}), {dedupingInterval: 30000, revalidateOnFocus: true, shouldRetryOnError: true, errorRetryCount: 3, errorRetryInterval: 15000});

export default useAlertas;